export const UserSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.5 15.625a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5zM3.027 21.094a10.938 10.938 0 0118.946 0"
      />
    </svg>
  );
};
